"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactIntl = require("react-intl");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _without = _interopRequireDefault(require("lodash/without"));

var _Button = _interopRequireDefault(require("@cimpress/react-components/lib/Button"));

var _colors = require("@cimpress/react-components/lib/colors");

var _keyValidators = require("../shared/validators/keyValidators");

var _propTypes2 = require("../shared/propTypes");

var _constraintActions = require("./constraintActions");

var _messages = _interopRequireDefault(require("./messages"));

var _conditionEditor = _interopRequireDefault(require("../shared/conditionEditor"));

var _predicateEditor = _interopRequireDefault(require("../shared/predicateEditor"));

var _commonStyles = require("../shared/commonStyles");

var _emotion = require("emotion");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n   {\n    border-top-color: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n   {\n    background-color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var ruleResultBackgroundColor = (0, _emotion.css)(_templateObject(), _colors.silver);
var darkerHr = (0, _emotion.css)(_templateObject2(), _colors.platinum);

var ConstraintEditor =
/*#__PURE__*/
function (_Component) {
  _inherits(ConstraintEditor, _Component);

  var _super = _createSuper(ConstraintEditor);

  function ConstraintEditor() {
    var _this;

    _classCallCheck(this, ConstraintEditor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onAddCondition", function () {
      return _this.props.onChange(_this.props.rule.name, (0, _constraintActions.addCondition)(_this.props.rule));
    });

    _defineProperty(_assertThisInitialized(_this), "onUpdateCondition", function (originalCondition, condition) {
      return _this.props.onChange(_this.props.rule.name, (0, _constraintActions.updateCondition)(_this.props.rule, originalCondition, condition));
    });

    _defineProperty(_assertThisInitialized(_this), "onRemoveCondition", function (originalCondition, condition) {
      return _this.props.onChange(_this.props.rule.name, (0, _constraintActions.removeCondition)(_this.props.rule, originalCondition, condition));
    });

    _defineProperty(_assertThisInitialized(_this), "onAddResult", function () {
      return _this.props.onChange(_this.props.rule.name, (0, _constraintActions.addResult)(_this.props.rule));
    });

    _defineProperty(_assertThisInitialized(_this), "onUpdateResult", function (originalResult, result) {
      return _this.props.onChange(_this.props.rule.name, (0, _constraintActions.updateResult)(_this.props.rule, originalResult, result));
    });

    _defineProperty(_assertThisInitialized(_this), "onRemoveResult", function (originalResult, result) {
      return _this.props.onChange(_this.props.rule.name, (0, _constraintActions.removeResult)(_this.props.rule, originalResult, result));
    });

    _defineProperty(_assertThisInitialized(_this), "validateName", function (newName) {
      var formatMessage = _this.props.intl.formatMessage;

      if (newName === _this.props.rule.name) {
        return '';
      }

      if (!newName) {
        return formatMessage(_messages["default"].mustProvideRuleName);
      }

      return (0, _keyValidators.validateRuleName)(newName, _this.props.constraintRules, 'Rule');
    });

    return _this;
  }

  _createClass(ConstraintEditor, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          rule = _this$props.rule,
          options = _this$props.options,
          formatMessage = _this$props.intl.formatMessage;

      if (!rule) {
        return null;
      }

      var usedOptions = [].concat(_toConsumableArray(rule.conditions), _toConsumableArray(rule.results)).map(function (condition) {
        return condition.attribute;
      }).filter(function (c) {
        return c;
      });

      var remainingOptions = _without["default"].apply(void 0, [Object.keys(options)].concat(_toConsumableArray(usedOptions)));

      return (
        /*#__PURE__*/
        _react["default"].createElement(_react.Fragment, null,
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "card-block"
        },
        /*#__PURE__*/
        _react["default"].createElement("p", null,
        /*#__PURE__*/
        _react["default"].createElement("b", null, formatMessage(_messages["default"].ruleConditionMessage))),
        /*#__PURE__*/
        _react["default"].createElement(_predicateEditor["default"], {
          conditions: rule.conditions,
          results: rule.results,
          attributes: options,
          addCondition: this.onAddCondition,
          updateCondition: this.onUpdateCondition,
          removeCondition: this.onRemoveCondition
        }),
        /*#__PURE__*/
        _react["default"].createElement("br", null)),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: (0, _emotion.cx)('card-block', ruleResultBackgroundColor)
        },
        /*#__PURE__*/
        _react["default"].createElement("p", null,
        /*#__PURE__*/
        _react["default"].createElement("b", null, formatMessage(_messages["default"].ruleResultMessage))), rule.results.map(function (result, i) {
          return (
            /*#__PURE__*/
            _react["default"].createElement(_react.Fragment, {
              key: result.attribute || i
            },
            /*#__PURE__*/
            _react["default"].createElement(_conditionEditor["default"], {
              style: _commonStyles.tenPxMarginTop,
              condition: result,
              conditions: rule.conditions,
              results: rule.results,
              attributes: options,
              updateCondition: _this2.onUpdateResult,
              removeCondition: _this2.onRemoveResult
            }), i < rule.results.length - 1 &&
            /*#__PURE__*/
            _react["default"].createElement("hr", {
              className: darkerHr
            }))
          );
        }), !rule.results.length &&
        /*#__PURE__*/
        _react["default"].createElement("div", null,
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "text-muted h5"
        }, formatMessage(_messages["default"].noResultsForRule))),
        /*#__PURE__*/
        _react["default"].createElement(_Button["default"], {
          className: _commonStyles.tenPxMarginTop,
          type: "default",
          onClick: this.onAddResult,
          disabled: !remainingOptions.length
        }, formatMessage(_messages["default"].addResult))))
      );
    }
  }]);

  return ConstraintEditor;
}(_react.Component);

_defineProperty(ConstraintEditor, "propTypes", {
  rule: _propTypes["default"].shape(_propTypes2.constraintRuleShape),
  constraintRules: _propTypes["default"].arrayOf(_propTypes["default"].shape()).isRequired,
  options: _propTypes["default"].shape({}).isRequired,
  intl: _propTypes["default"].shape(_propTypes2.intlShape).isRequired
});

_defineProperty(ConstraintEditor, "defaultProps", {
  rule: undefined
});

var _default = (0, _reactIntl.injectIntl)(ConstraintEditor);

exports["default"] = _default;